export const colors = {
  type: {
    10: '#377EB8',
    20: '#FFFF33',
    30: '#FF7F00',
    40: '#E41A1C',
  },
  priority: {
    1: '#CD242B',
    2: '#D9823B',
    3: '#683967',
    4: '#65C87A',
  },
  confidence: {
    3: '#CD242B',
    2: '#D9823B',
    1: '#65C87A',
  },
  severity: {
    3: '#CD242B',
    2: '#D9823B',
    1: '#65C87A',
  },
};



// WEBPACK FOOTER //
// ./src/lib/colors.js